import agentApiService from "../../../../services/travel/new-policy/agentApiService";
import clientApiService from "../../../../services/travel/new-policy/clientApiService";

const validateIdentificationNumber = (clientId: string, identificationNumber: string) =>
  clientId
    ? clientApiService.validateIdentificationNumber(clientId, identificationNumber)
    : agentApiService.validateIdentificationNumber(identificationNumber);

export default validateIdentificationNumber;
